import React from 'react';
import './VideoContainer.css';

export default function VideoContainer({ video, onDelete }) {
  return (
    <div className="video-container">
      <div className="video-wrapper">
        <video 
          src={video.getVideoObjectUrl()} 
          className="video-element"
        />
      </div>
      <div className="video-info">
        <p className="video-title">{video.getVideoName()}</p>
        <div className="video-actions">
          <button 
            onClick={() => onDelete(video)}
            className="btn btn-danger btn-sm"
          >
            Usuń
          </button>
        </div>
      </div>
    </div>
  );
} 